import { ChangeDetectionStrategy, Component, inject, signal } from '@angular/core';
import { FileParameter } from 'src/app/client-api.service';
import { ImagesService } from 'src/app/shared/image-service';
import { UserService } from 'src/app/shared/user.service';

@Component({
  selector: 'app-image-upload',
  //imports: [],
  templateUrl: './image-upload.component.html',
  styles: ``,
  changeDetection: ChangeDetectionStrategy.OnPush,
  standalone: false
})
export class ImageUploadComponent {

  imageService = inject(ImagesService)
  userService = inject(UserService);
  images = signal<{ file: File; previewUrl: string }[]>([]);

  uploading = signal(false);
  uploadProgress = signal(0);
  error = signal<string | null>(null);
  dragActive = signal(false);

  handleFiles(files: File[]) {
    const existingNames = new Set(this.images().map(img => img.file.name));
    const validFiles = files.filter(f => f.type.startsWith('image/') && !existingNames.has(f.name));

    const fileReaders = validFiles.map(file => new Promise<{ file: File; previewUrl: string }>((resolve, reject) => {
      const reader = new FileReader();
      reader.onload = () => resolve({ file, previewUrl: reader.result as string });
      reader.onerror = err => reject(err);
      reader.readAsDataURL(file);
    }));

    Promise.all(fileReaders)
      .then(added => this.images.set([...this.images(), ...added]))
      .catch(() => this.error.set('Could not read some files.'));
  }

  onDragOver(isOver: any) {    
    this.dragActive.set(isOver);
  }

  onFilesDropped(files: any) {
    this.handleFiles(Array.from(files));
  }

  onFilesSelected(event: Event) {
    const input = event.target as HTMLInputElement;
    if (!input.files) return;
    this.handleFiles(Array.from(input.files));
    input.value = '';
  }

  uploadImages() {
    if (!this.images().length) return;
    this.uploading.set(true);
    this.uploadProgress.set(0);
    this.error.set(null);

    const uploadObservables = this.images().map(({ file }) => {

      const orgCode = file.name.split('.')[0];
      return this.imageService.postImage(
        file.name,
        this.toFileParameter(file),
        this.userService.curremntUserName()!,
        orgCode
      );
    });

    let completed = 0;
    uploadObservables.forEach(obs => {
      obs.subscribe({
        next: () => {
          completed++;
          this.uploadProgress.set(Math.round(100 * completed / uploadObservables.length));
          if (completed === uploadObservables.length) {
            this.uploading.set(false);
            this.images.set([]);
            alert('Uploaded!');
          }
        },
        error: err => {
          this.uploading.set(false);
          this.error.set('Upload failed for one or more images.');
        }
      });
    });
  }

  removeImage(idx: number) {
    const updated = [...this.images()];
    updated.splice(idx, 1);
    this.images.set(updated);
  }

  private toFileParameter(file: File): FileParameter {
    return {
      data: file,
      fileName: file.name
    };
  }
}
